exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.auth-page{background:#fff\n}", "", {"version":3,"sources":["/home/ylp/ylp-leadmall-c/src/module/app/meituAuth/page.vue"],"names":[],"mappings":";AACA,WAAW,eAAe;CACzB","file":"page.vue","sourcesContent":["\n.auth-page{background:#fff\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1938c6c5","scoped":false,"hasInlineConfig":false}!./node_modules/vux-loader/src/after-less-loader.js!./node_modules/less-loader?{"sourceMap":true}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/module/app/meituAuth/page.vue
// module id = TVNv
// module chunks = 1